module.exports = __webpack_public_path__ + "static/img/static/img/pre_rotate.d633af7c.png";